import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';

export function EmptyTags() {
  return (
    <CenteredLayout>
      <div>
        <h2 className="h3 mb-16">You don’t have any tags set up</h2>
        <ul className="ul-lt">
          <li>Tags are facets of identity and take the form “key:value” (e.g. “env:prod”).</li>
          <li>They can apply advanced configuration to groups of hosts, lighthouses, and relays.</li>
          <li>They can be used in addition to roles to create more granular firewall rules.</li>
        </ul>
        <LinkButton to="add">Add tag</LinkButton>
      </div>
    </CenteredLayout>
  );
}
